<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <!-- <el-input
          v-model="getQuestionPaperRecordList_data.qpName"
          placeholder="请输入试卷名称"
          clearable
          size='small'
          style="max-width:380px;"/> -->
        <el-select v-model='getQuestionPaperRecordList_data.qpId' clearable filterable @change="getList" size="small">
          <el-option v-for="item in getQuestionPaperList_data.data || []"
            :key="item.qpId" 
            :label="item.qpName + (item.qpTypeDo == 1 ? '(考试)':'(练习)')"
            :value="item.qpId">
          </el-option>
        </el-select>
        <el-select v-model="getQuestionPaperRecordList_data.qprStatus" clearable placeholder="状态" size="small" style="max-width:150px;"
            @change="getList2">
            <el-option label="未提交" :value="1"></el-option>
            <el-option label="已提交" :value="2"></el-option>
            <el-option label="已批阅" :value="3"></el-option>
        </el-select>
        <el-button v-click.getQuestionPaperRecordList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
        <el-button @click="Bulksure()" type="success" icon="el-icon-search" size="small" style="margin-left:10px;">导出
        </el-button>
      </el-col>
      <el-col :span="6">
      </el-col>
    </el-row>

    <mytable :tableColums='tableColums_getQuestionPaperRecordList' api='getQuestionPaperRecordList'
      updateapi='updateQuestionPaperRecordShowScore' :height="H - 165">
    </mytable>

    <myform width="80%" view.getQuestionPaperRecordDetails="批阅" @opened='arguments[0].title += " | @" + row.userName'
      @close='$form("getQuestionPaperRecordDetails", "hide"), getQuestionPaperRecordList()'>
      <mytable :tableColums='tableColums_getQuestionPaperRecordDetails' api='getQuestionPaperRecordDetails'
        xupdateapi='updateQuestionPaperRecordScore' :height="H - 285">
        <icol slot='questionTopicItemList' slot-scope='{row}' show-overflow-tooltip>
          <div v-for="item in row.questionTopicItemList" :key="item.qtiId">
            <span v-if="item.qtiIsAnswer == 2" style="color:green;">{{ item.qtiValue }}</span>
            <span v-else>{{ item.qtiValue }}</span>
          </div>
        </icol>
        <icol slot='qtScoreUser' slot-scope='{row}' show-overflow-tooltip>
          <el-row>
            <el-col :span="12">
              {{ row.qtScoreUser }}
            </el-col>
            <el-col :span="12" v-if="row.qttId == 4 || row.qttId == 5">
              <el-button size="small" type="text" @click="toEditScore(row)">编辑</el-button>
            </el-col>
          </el-row>
        </icol>
        <icol slot='questionPaperTopicRecord' slot-scope='{row}' show-overflow-tooltip>
          <div v-if="row.qttId == 1 || row.qttId == 2 || row.qttId == 3">
            {{ row.qptAnswerDes }}
          </div>
          <div v-else>
            {{ row.qptAnswerDes }}
          </div>
        </icol>
      </mytable>
      <hide slot='qprId' />
      <hide slot='qptrId' />
    </myform>
    <myform :viewobj='{
      updateQuestionPaperRecordScore: ["得分", "el-icon-edit-outline"],
      $succeed$: getQuestionPaperRecordDetails
    }' @close='$form("updateQuestionPaperRecordScore", "reset")' @confirm='myformQuestionPaperRecordScore'>
      <hide slot='qprId' />
      <hide slot='qptrId' />
      <template v-slot:qtScoreUser="{ Myformdata }">
        <el-input v-model="Myformdata.qtScoreUser" type="number" size="small"></el-input>
      </template>
    </myform>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
export default {
  data() {
    return {
      attrId: null,
      baseUrl: $Api.baseUrl_online,
      row: {},
      rowTem: {},

      tableColums_getQuestionPaperRecordList: {
        $selection: false,

        userName: '答题人',

        qpName: '试卷名称',
        qpTypeDo:['考试类型', , '@v-if: 1:考试#danger, 2:练习#danger'],
        qprStatus: ['状态', , '@v-if: 1:未提交#danger, 2:已提交#success, 3:已批阅#success'],

        qprObjectiveScore: '客观题得分',

        qprScore: '主观题得分',

        qprShowScore: '最终得分',

        createtime: '答题时间',

        $operation: [
          '操作', 200,
          this.getQuestionPaperRecordDetails && `@text: 批阅#success
           @click: $form("getQuestionPaperRecordDetails",$this.row = $row),
           getQuestionPaperRecordDetails({qprId:$row.qprId})
          `,
        ],

      },

      tableColums_getQuestionPaperRecordDetails: {
        $selection: false,

        qtName: '题目名称',
        btName: '业务类型',
        qttName: '题目类型',
        qtScore: '题目分值',
        qtScoreUser: '得分',
        questionTopicItemList: ['选项答案', 300],
        questionPaperTopicRecord: ['作答', 300],

      },

    };
  },

  watch: {

  },

  methods: {
    openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    Bulksure() {
      const bulkdata = {
        projectId: this.theProjectId,
        qpId: this.getQuestionPaperRecordList_data.qpId,
        qprStatus: this.getQuestionPaperRecordList_data.qprStatus,
      };
      this.openLoading();
      var s = qs.stringify(bulkdata);
      var that = this;
      axios({
        method: "post",
        url:
          that.baseUrl +
          "/opportunity/question-paper-record/exportQuestionPaperRecordList",
        data: s,
        withCredentials: true,
        timeout: 1200000,
        responseType: "arraybuffer",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          token: A.local("$Usertoken"),
          projectId: +A.local("$projectId")
        }
      }).then(function (res) {
        if (res.data) {
          that.loading.close();
          let a = document.createElement("a");
          //ArrayBuffer 转为 Blob
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel"
          });
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", "答题记录.xlsx");
          a.click();
          that.$message({
            message: "成功",
            type: "success"
          });
        }
      });
    },
    getList(e) {
      this.getQuestionPaperRecordList({ qpId: e })
    },
    getList2(e) {
      this.getQuestionPaperRecordList({ qprStatus: e })
    },
    
    toEditScore(row) {
      this.$form("updateQuestionPaperRecordScore", this.row = row);
    },
    myformQuestionPaperRecordScore(submit, Myformdata) {
      Myformdata.qprId = this.row.qprId;
      Myformdata.qptrId = this.row.qptrId;
      submit();
    },
  },

  created() {
    this.theUserProject = A.local("$projectId");
    if (this.theUserProject == 0) {
      this.getProjectList({
        pageSize: 0
      });
    } else {
      this.theProjectId = this.theUserProject;
    }
    this.getQuestionPaperRecordList();
    this.getQuestionPaperList()
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/paper/PaperAnswerManage.vue